// extracted by mini-css-extract-plugin
export var footer = "_nv-5";
export var fulfillmentInput = "_nv-0";
export var shipDateInput = "_nv-1";
export var shipmentModal = "_nv-2";
export var shipmentModalContent = "_nv-3";
export var tableContainer = "_nv-4";